import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { closeCurrentModal } from 'redux/slices/modals/modals.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal } from 'redux/selectors/selectors';
import { EModalsNames } from 'shared/types/modal.interface';
import { ModalContainer } from 'components/Modals/ModalContainer';
import { CHANGE_PASSWORD_MODAL_DATA } from 'shared/constants/modal-constants';
import { ChangePasswordForm } from 'components/Forms/ChangePasswordForm/ChangePasswordForm';

export const ChangePasswordModal: React.FC = () => {
  const currentModal = useAppSelector(selectCurrentModal);
  const dispatch = useAppDispatch();

  if (currentModal.entityName !== EModalsNames.ChangePasswordModal) return null;

  return (
    <ModalContainer
      onClose={() => dispatch(closeCurrentModal())}
      isOpen={currentModal.entityName === EModalsNames.ChangePasswordModal}
    >
      <Stack alignItems="stretch" width="100%">
        <Typography
          variant="h2"
          color="primary.main"
          alignSelf="center"
          sx={{ marginBottom: { lg: '66px', md: '48px', sm: '48px', xs: '48px' } }}
        >
          {CHANGE_PASSWORD_MODAL_DATA.title}
        </Typography>
        <ChangePasswordForm />
      </Stack>
    </ModalContainer>
  );
};
